import store from "../store"

const defaultState = {
    byIds: {},
    allIds: [],
    loading: false,
    error: undefined
} 

const authReducer = (state = defaultState, action) => {
    switch(action.type) {
        case "GET_COLORS_REQUEST": 
            return { ...state, loading: true }
        case "GET_COLORS_SUCCESS":
            let { colors } = action.payload.data
            for (let color of colors) {
                state.byIds[color.id] = color
                if (state.allIds.indexOf(color.id) === -1) state.allIds.push(color.id);
            }
            return { ...state, error: undefined, loading: false, allIds: [ ...state.allIds ], byIds: { ...state.byIds } }
        case "GET_COLORS_FAILED":
            return { ...state, error: action.error, loading: false, allIds: [ ...state.allIds ], byIds: { ...state.byIds } }
        default:
            return state;
    }
}

export default authReducer;